import type { Theme } from '@mui/material/styles';

const arrow = (points: string) =>
  `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpolygon fill='%23777' points='${points}'/%3E%3C/svg%3E")`;

// Reserve the measured sticky header height before the top arrow.
export const tableScrollbarSx = {
  '&::-webkit-scrollbar': { width: 12, height: 12, backgroundColor: 'primary.main' },
  '&::-webkit-scrollbar-track': { backgroundColor: 'background.paper' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: 'text.secondary', borderRadius: 6 },
  '&::-webkit-scrollbar-button:single-button': {
    display: 'block',
    width: 12,
    height: 12,
    backgroundColor: 'background.paper',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '8px 8px',
  },
  '&::-webkit-scrollbar-button:single-button:vertical:decrement': {
    height: 'calc(var(--scrollbar-header-height, 32px) + 12px)',
    backgroundImage: (theme: Theme) =>
      `${arrow('6,2 1,9 11,9')}, linear-gradient(to bottom, ${theme.palette.primary.main} 0 var(--scrollbar-header-height, 32px), ${theme.palette.background.paper} var(--scrollbar-header-height, 32px))`,
    backgroundSize: '8px 8px, 100% 100%',
    backgroundPosition: 'center bottom 2px, center',
  },
  '&::-webkit-scrollbar-button:single-button:vertical:increment': { backgroundImage: arrow('1,3 11,3 6,10') },
  '&::-webkit-scrollbar-button:single-button:horizontal:decrement': { backgroundImage: arrow('2,6 9,1 9,11') },
  '&::-webkit-scrollbar-button:single-button:horizontal:increment': { backgroundImage: arrow('3,1 10,6 3,11') },
} as const;

export const offerTableScrollSx = {
  ...tableScrollbarSx,
  flex: 1,
  minHeight: 0,
  overflowX: 'scroll',
  overflowY: 'auto',
  backgroundImage: (theme: Theme) =>
    `linear-gradient(to bottom, ${theme.palette.primary.main} 0 var(--scrollbar-header-height, 32px), ${theme.palette.background.paper} var(--scrollbar-header-height, 32px))`,
  '@media print': { overflow: 'visible' },
} as const;
